// extracted by mini-css-extract-plugin
export var active = "_lz-2";
export var recordingDot = "_lz-1";
export var recordingIndicator = "_lz-0";